import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { useLanguage } from "@/i18n/useLanguage";

interface PageBreadcrumbProps {
  /** Translation key under "breadcrumb.*" (e.g. "about"). Falls back to raw string. */
  currentPage: string;
}

const PageBreadcrumb = ({ currentPage }: PageBreadcrumbProps) => {
  const { t } = useTranslation();
  const { localize } = useLanguage();
  const key = `breadcrumb.${currentPage.toLowerCase()}`;
  const label = t(key, { defaultValue: currentPage });

  return (
    <div className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-6 py-3">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={localize("/")} className="text-primary hover:text-primary/80">
                  {t("breadcrumb.home")}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-foreground">{label}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  );
};

export default PageBreadcrumb;
